module.exports = __webpack_public_path__ + "img/lueder.2c97a9d5.jpg";